import agentsApiConfig from 'api/agents';
import { HTTP_METHODS } from 'config';

export const fetchRentFlowsRequest = ({
  step,
  startDate,
  endDate,
  daysAgo,
  currentPage,
  pageSize,
  pageBeginToken,
  pageEndToken,
  stepsWithMetadata,
}) => {
  let url =
    `rent-flows?step=${step}&startDate=${startDate}&endDate=${endDate}` +
    `&sortedBy=CREATED_AT_DESC&daysAgo=${daysAgo}&currentPage=${currentPage}&pageSize=${pageSize}`;

  if (pageBeginToken && pageEndToken) {
    url = url.concat(
      `&pageBeginToken=${pageBeginToken}&pageEndToken=${pageEndToken}`,
    );
  }

  if (stepsWithMetadata && stepsWithMetadata.length > 0) {
    url = url.concat(`&stepsWithMetadata=${stepsWithMetadata.join(',')}`);
  }

  return agentsApiConfig({
    endpoint: url,
    method: HTTP_METHODS.GET,
  });
};
